import {TreeComponent, TreeNode} from '../../common/tree/tree.component';
import {Utils} from '../../common/utils';
import {Component, SimpleChanges} from '@angular/core';
import {DynamicImageSet} from 'src/app/model/dynamic-image-set';
import {Observable} from 'rxjs';
import {ErrorHelper} from '../../common/ErrorHelper';

@Component({
  selector: 'app-layers-tree-component',
  templateUrl: '../../common/tree/tree.component.html',
  styleUrls: ['../../common/tree/tree.component.scss'],
})

export class LayersTreeComponent extends TreeComponent {

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.id && changes.id.currentValue !== changes.id.previousValue
      || changes.version && changes.version.currentValue !== changes.version.previousValue
      || changes.viewport && changes.viewport.currentValue !== changes.viewport.previousValue) {
        this.initialize();
        this.loadDataAsync();
    } else {
      this.images = [];
      this.angles = this.dynamicImageSet.previewAngles;
      this.loadOnlyImagesAsync();
    }
  }

  loadPreselectedNodes(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getPreselectedLayers(this.dynamicImageSet, this.testArea).toPromise().then(
        (data) => {
          this.preselectedLayerNodes = data;
          console.log('Fetched all the preselected layers');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load preselected layers', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

  loadTreeData(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      return this.apiService.getLayers(this.dynamicImageSet, this.testArea).toPromise().then(
        (data) => {
          console.log('Fetched all the layers');
          const dataGroupedByFamilyName = Utils.groupBy(data, ['familyName']);
          this.dataSource.data = this.buildTree(dataGroupedByFamilyName, 0);
          console.log('Layers tree built');
          resolve(true);
        },
        (error) => {
          const errorMessage = ErrorHelper.disectError('load layers', error);
          this.notifierService.notify('error', errorMessage);
          resolve(false);
        });
    });
  }

  buildTree(obj: { [key: string]: any }, level: number): TreeNode[] {
    return Object.keys(obj).reduce<TreeNode[]>((accumulator, key) => {
      const value = obj[key];
      const node = new TreeNode();
      node.item = key;

      if (value != null) {
        if (Array.isArray(value)) {
          node.children = this.buildTree(value, level + 1);
          const noneNode = new TreeNode();
          noneNode.item = 'none';
          node.children.push(noneNode);
        } else {
          node.item = value.name;
          node.description = value.description;
        }
      }

      return accumulator.concat(node);
    }, []);
  }

  getImage(dynamicImageSet: DynamicImageSet, selectedNodes: string[], view: string): Observable<Blob> {
    return this.apiService.getImageBasedOnLayers(dynamicImageSet, selectedNodes, view, this.testArea);
  }

}
